import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchVenues } from "../../api/venuesApi";

export const fetchVenuesThunk = createAsyncThunk(
  "venues/fetchVenues",
  async ({ venues_ids }, { rejectWithValue }) => {
    try {
      const response = await fetchVenues({ venues_ids });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const venuesSlice = createSlice({
  name: "venues",
  initialState: {
    venues: [],
    status: "idle", // "idle", "loading", "succeeded", "failed"
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVenuesThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchVenuesThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.venues = action.payload;
      })
      .addCase(fetchVenuesThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Something went wrong.";
      });
  },
});

export default venuesSlice.reducer;
